<div class="col">
  @if (showOrderInfo) {
    <p-panel
      [header]="
        'Individual_Production_Card_General_Information_OrderInformation'
          | translateWF
            : 'Order
      Information'
      "
    >
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_WorkOrder' | translateWF: 'Work Order' }}</label>
            <input pInputText type="text" class="w-full" [value]="workOrder?.orderNumber" disabled />
          </div>
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_ClientPO' | translateWF: 'Client PO' }}</label>
            <input pInputText type="text" class="w-full" [value]="clientPO" disabled />
          </div>
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_Client' | translateWF: 'Client' }}</label>
            <input pInputText type="text" class="w-full" [value]="workOrder?.customer?.name" disabled />
          </div>
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_Brand' | translateWF: 'Brand' }}</label>
            <input pInputText type="text" class="w-full" [value]="workOrder?.brand?.name" disabled />
          </div>
        </div>
      </p-card>
    </p-panel>
  }

  @if (showDyeingInfo) {
    <p-panel [header]="'Individual_Production_Card_General_Information_DyeingInformation' | translateWF: 'Dyeing Information'">
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_Color' | translateWF: 'Color' }}</label>
            <input pInputText type="text" class="w-full" [value]="dyeingColor?.name" disabled />
          </div>
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_LabDipNumber' | translateWF: 'Lab Dip Number' }}</label>
            <input pInputText type="text" class="w-full" [value]="dyeingColor?.approvedRecipeNumber" disabled />
          </div>
          <div class="form-box">
            <label for="">{{
              'Individual_Production_Card_General_Information_DyeingMachine'
                | translateWF
                  : 'Dyeing
            Machine'
            }}</label>
            <input pInputText type="text" class="w-full" [value]="dyeingAsset?.assetId" disabled />
          </div>
          <div class="form-box">
            <label for="">{{ 'Individual_Production_Card_General_Information_NoPorts' | translateWF: 'No. Ports' }}</label>
            <input pInputText type="text" class="w-full" [value]="dyeingAsset?.dyeingMachineDetails?.numberOfPorts" disabled />
          </div>
        </div>
      </p-card>
    </p-panel>
  }

  @if (showManufacturerTable && manufacturerAndLotNumber.length > 0) {
    <p-card data-variant="compact">
      <p-table [value]="manufacturerAndLotNumber">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Individual_Production_Card_General_Information_Manufacturer' | translateWF: 'Manufacturer' }}</th>
            <th>{{ 'Individual_Production_Card_General_Information_LotNumber' | translateWF: 'Lot Number' }}</th>
            <th>{{ 'Individual_Production_Card_General_Information_FabricCodes' | translateWF: 'Fabric Codes' }}</th>
            <th>{{ 'Individual_Production_Card_General_Information_RollCount' | translateWF: 'Roll Count' }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          @let strictManufacturerAndLotNumber = getStrictManufacturerLotNumber(item);
          <tr>
            <td>{{ strictManufacturerAndLotNumber.manufacturer }}</td>
            <td>{{ strictManufacturerAndLotNumber.lotNumber }}</td>
            <td>
              <ng-container *ngFor="let fabricCode of strictManufacturerAndLotNumber.fabricCodes; let isLast = last">
                {{ fabricCode }}<span *ngIf="!isLast">, </span>
              </ng-container>
            </td>
            <td>{{ strictManufacturerAndLotNumber.rollCount }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
  @if (showBalanceTable) {
    <p-card data-variant="compact">
      <app-fabric-summary-table [productionCard]="productionCard" [fabrics]="fabrics" [rolls]="rolls" [bundles]="bundles" [showFabricsWithoutRolls]="showFabricsWithoutRolls" />
    </p-card>
  }
</div>
